module.exports = __webpack_public_path__ + "static/media/logo.aaeeea72.svg";